export default "https://housescan.app.solease.nl/static/media/glass_insulation_2.3bfc2aa2.svg";